/* global attachEvent */

// **********************************************************
// Open Content
// **********************************************************
attachEvent('.purchase-button .btn', 'click', (ev) => {
  const parentElem = ev.target.closest('.purchase-button');

  const closeContent = () => {
    document.querySelectorAll('.purchase-button.is-open').forEach((elem) => {
      elem.classList.remove('is-open');
    });
  };

  if (parentElem.classList.contains('is-open')) {
    closeContent();
  } else {
    closeContent();
    parentElem.classList.add('is-open');
  }
});
